import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, adminOnly = false, posterOnly = false, artistOnly = false }) => {
    const { isAuthenticated, isAdmin, isPoster, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen bg-[#121212] flex items-center justify-center">
                <div className="animate-pulse">
                    <div className="w-12 h-12 border-4 border-[#F51E1E] border-t-transparent rounded-full animate-spin"></div>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Admin-only routes
    if (adminOnly && !isAdmin) {
        return <Navigate to={isPoster ? "/poster/dashboard" : "/opportunities"} replace />;
    }

    // Poster-only routes (poster dashboard, create project, manage project)
    if (posterOnly && !isPoster && !isAdmin) {
        return <Navigate to="/opportunities" replace />;
    }

    // Artist-only routes (opportunities, submissions) - block posters
    if (artistOnly && isPoster) {
        return <Navigate to="/poster/dashboard" replace />;
    }

    return children;
};
